<template>
    <div class="zuke_index">
        <div class="head_box">
            <div class="head_top_box">
                <div class="head_top">
                    <a href="javascript:;" @click="baike_back()"><img src="../../assets/images/left.png" alt=""></a>
                    <h1>租客百科</h1>
                    <div class="head_top_btn"></div>
                </div>
            </div>
        </div>
        <div class="search_box">
            <div class="search_btn">
                <div class="search_btn_list" @click='search_btn(1)' :class='search_index == 1 ? "active" : ""'>小区<p></p></div>
                <div class="search_btn_list" @click='search_btn(2)' :class='search_index == 2 ? "active" : ""'>公司<p></p></div>
                <div class="search_btn_list" @click='search_btn(3)' :class='search_index == 3 ? "active" : ""'>商圈<p></p></div>
                <div class="search_btn_list" @click='search_btn(4)' :class='search_index == 4 ? "active" : ""'>品牌公寓<p></p></div>
                <div class="search_btn_list" @click='search_btn(5)' :class='search_index == 5 ? "active" : ""'>写字楼<p></p></div>
                <div class="search_btn_list" @click='search_btn(6)' :class='search_index == 6 ? "active" : ""'>商业综合体/商铺<p></p></div>
                <div class="search_btn_list" @click='search_btn(7)' :class='search_index == 7 ? "active" : ""'>创业孵化器<p></p></div>
                <div class="search_btn_list" @click='search_btn(8)' :class='search_index == 8 ? "active" : ""'>物业公司<p></p></div>
            </div>
            <router-link :to="{name:'baike_search',params:{name:search_index}}" class="search">
                <input type="text" placeholder="请输入您要搜索的词条" readonly4>
                <div class="search_state">
                    <img src="../../assets/images/index/search.png" alt="">
                </div>
            </router-link>
            <div class="hot_search">
                <div class="hot_title">热搜 |</div>
                <div class="hot_list" v-for="hot in homeData.hot">
                <router-link :to="{name:'baike_list',params:{type:'hot.html',},query:{search:hot,}}">{{hot}}</router-link></div>
            </div>
        </div>
        <div class="index">
            <div class="new_entry">
                <div class="index_list_title">
                    <h2>最新词条</h2>
                </div>
                <div class="entry_box">
                    <div class="entry_list" v-for="entry in homeData.new">
                        <router-link :to="{name:'baike_detail',params:{sn:entry.sn + '.html'}}">
                            <div class="entry_img">
                                <img :src="entry.image" alt="">
                                <div class="label" v-if="entry.type == 10001">小区</div>
                                <div class="label" v-else-if="entry.type == 10002">公司</div>
                                <div class="label" v-else-if="entry.type == 10003">商圈</div>
                                <div class="label" v-else-if="entry.type == 10004">品牌公寓</div>
                                <div class="label" v-else-if="entry.type == 10005">写字楼</div>
                                <div class="label" v-else-if="entry.type == 10006">商业综合体/商铺</div>
                                <div class="label" v-else-if="entry.type == 10007">创业孵化器</div>
                                <div class="label" v-else-if="entry.type == 10008">物业公司</div>
                            </div>
                            <h3 class="entry_title">{{entry.name}}</h3>
                            <div class="entry_time">{{entry.createtime}}</div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="hot_xq">
                <div class="index_list_title">
                    <h2>热搜小区</h2>
                    <router-link :to="{name:'baike_list',params:{type:'xq.html',}}" class="more">查看更多&gt;</router-link>
                </div>
                <div class="hot_xq_list" v-for="hot_xq in homeData.xq">
                    <router-link :to="{name:'baike_detail',params:{sn:hot_xq.sn + '.html'}}">
                        <div class="hot_xq_img">
                            <img :src="hot_xq.image" alt="">
                        </div>
                        <div class="hot_xq_box">
                            <h3 class="hot_xq_title">{{hot_xq.name}}</h3>
                            <div class="hot_xq_i">
                                <div class="hot_xq_i_list">
                                    <div class="hot_xq_i_title">建造年代</div>
                                    <div class="hot_xq_i_text">{{hot_xq.attribute.jianzaoniandai}}</div>
                                </div>
                                <div class="hot_xq_i_list">
                                    <div class="hot_xq_i_title">建造面积</div>
                                    <div class="hot_xq_i_text">{{hot_xq.attribute.jianzhumianji}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="hot_xq_bot">
                            <img src="../../assets/images/index/location.png" alt="">
                            <div class="hot_xq_bot_title">{{hot_xq.attribute.address}}</div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="hot_company">
                <div class="index_list_title">
                    <h2>热搜企业</h2>
                    <router-link :to="{name:'baike_list',params:{type:'company.html',}}" class="more">查看更多&gt;</router-link>
                </div>
                <div class="hot_company_list" v-for="hot_company in homeData.company">
                    <router-link :to="{name:'baike_detail',params:{sn:hot_company.sn + '.html'}}">
                        <div class="hot_company_img">
                            <img :src="hot_company.image" alt="">
                        </div>
                        <div class="hot_company_box">
                            <h3 class="hot_company_title">{{hot_company.name}}</h3>
                            <div class="hot_company_i">
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">法人</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.faren}}</div>
                                </div>
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">成立时间</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.chenglishijian}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="hot_xq_bot">
                            <img src="../../assets/images/index/location.png" alt="">
                            <div class="hot_xq_bot_title">{{hot_company.attribute.address}}</div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="hot_company">
                <div class="index_list_title">
                    <h2>热搜商圈</h2>
                    <router-link :to="{name:'baike_list',params:{type:'sq.html',}}" class="more">查看更多&gt;</router-link>
                </div>
                <div class="hot_company_list" v-for="hot_company in homeData.sq">
                    <router-link :to="{name:'baike_detail',params:{sn:hot_company.sn + '.html'}}">
                        <div class="hot_company_img">
                            <img :src="hot_company.image" alt="">
                        </div>
                        <div class="hot_company_box">
                            <h3 class="hot_company_title">{{hot_company.name}}</h3>
                            <div class="hot_company_i">
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">城市</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.chengshi}}</div>
                                </div>
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">区县</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.quxian}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="hot_xq_bot">
                            <img src="../../assets/images/index/location.png" alt="">
                            <div class="hot_xq_bot_title">{{hot_company.attribute.address}}</div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="hot_company">
                <div class="index_list_title">
                    <h2>热搜公寓</h2>
                    <router-link :to="{name:'baike_list',params:{type:'apartment.html',}}" class="more">查看更多&gt;</router-link>
                </div>
                <div class="hot_company_list" v-for="hot_company in homeData.apartment">
                    <router-link :to="{name:'baike_detail',params:{sn:hot_company.sn + '.html'}}">
                        <div class="hot_company_img">
                            <img :src="hot_company.image" alt="">
                        </div>
                        <div class="hot_company_box">
                            <h3 class="hot_company_title">{{hot_company.name}}</h3>
                            <div class="hot_company_i">
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">建造年代</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.jianzaoniandai}}</div>
                                </div>
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">建造面积</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.jianzhumianji}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="hot_xq_bot">
                            <img src="../../assets/images/index/location.png" alt="">
                            <div class="hot_xq_bot_title">{{hot_company.attribute.address}}</div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="hot_company">
                <div class="index_list_title">
                    <h2>热搜写字楼</h2>
                    <router-link :to="{name:'baike_list',params:{type:'office.html',}}" class="more">查看更多&gt;</router-link>
                </div>
                <div class="hot_company_list" v-for="hot_company in homeData.office">
                    <router-link :to="{name:'baike_detail',params:{sn:hot_company.sn + '.html'}}">
                        <div class="hot_company_img">
                            <img :src="hot_company.image" alt="">
                        </div>
                        <div class="hot_company_box">
                            <h3 class="hot_company_title">{{hot_company.name}}</h3>
                            <div class="hot_company_i">
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">建造年代</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.jianzaoniandai}}</div>
                                </div>
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">建造面积</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.jianzhumianji}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="hot_xq_bot">
                            <img src="../../assets/images/index/location.png" alt="">
                            <div class="hot_xq_bot_title">{{hot_company.attribute.address}}</div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="hot_company">
                <div class="index_list_title">
                    <h2>热搜商业综合体/商铺</h2>
                    <router-link :to="{name:'baike_list',params:{type:'shop.html',}}" class="more">查看更多&gt;</router-link>
                </div>
                <div class="hot_company_list" v-for="hot_company in homeData.shop">
                    <router-link :to="{name:'baike_detail',params:{sn:hot_company.sn + '.html'}}">
                        <div class="hot_company_img">
                            <img :src="hot_company.image" alt="">
                        </div>
                        <div class="hot_company_box">
                            <h3 class="hot_company_title">{{hot_company.name}}</h3>
                            <div class="hot_company_i">
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">建造年代</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.jianzaoniandai}}</div>
                                </div>
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">建造面积</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.jianzhumianji}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="hot_xq_bot">
                            <img src="../../assets/images/index/location.png" alt="">
                            <div class="hot_xq_bot_title">{{hot_company.attribute.address}}</div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="hot_company">
                <div class="index_list_title">
                    <h2>热搜创业孵化器</h2>
                    <router-link :to="{name:'baike_list',params:{type:'incubator.html',}}" class="more">查看更多&gt;</router-link>
                </div>
                <div class="hot_company_list" v-for="hot_company in homeData.incubator">
                    <router-link :to="{name:'baike_detail',params:{sn:hot_company.sn + '.html'}}">
                        <div class="hot_company_img">
                            <img :src="hot_company.image" alt="">
                        </div>
                        <div class="hot_company_box">
                            <h3 class="hot_company_title">{{hot_company.name}}</h3>
                            <div class="hot_company_i">
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">建造年代</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.jianzaoniandai}}</div>
                                </div>
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">建造面积</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.jianzhumianji}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="hot_xq_bot">
                            <img src="../../assets/images/index/location.png" alt="">
                            <div class="hot_xq_bot_title">{{hot_company.attribute.address}}</div>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="hot_company">
                <div class="index_list_title">
                    <h2>热搜物业</h2>
                    <router-link :to="{name:'baike_list',params:{type:'wygs.html',}}" class="more">查看更多&gt;</router-link>
                </div>
                <div class="hot_company_list" v-for="hot_company in homeData.wygs">
                    <router-link :to="{name:'baike_detail',params:{sn:hot_company.sn + '.html'}}">
                        <div class="hot_company_img">
                            <img :src="hot_company.image" alt="">
                        </div>
                        <div class="hot_company_box">
                            <h3 class="hot_company_title">{{hot_company.name}}</h3>
                            <div class="hot_company_i">
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">城市</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.chengshi}}</div>
                                </div>
                                <div class="hot_company_i_list">
                                    <div class="hot_company_i_title">成立时间</div>
                                    <div class="hot_company_i_text">{{hot_company.attribute.chenglishijian}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="hot_xq_bot">
                            <img src="../../assets/images/index/location.png" alt="">
                            <div class="hot_xq_bot_title">{{hot_company.attribute.address}}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <footerBox></footerBox>
    </div>
</template>

<script>
    import footerBox from './footerBox.vue';
    export default {
        name: "baike_index",
        data:()=>{
            return {
                search_index:1,
            }
        },
        components:{
            footerBox,
        },
        asyncData ({ store}) {
            return store.dispatch('fetch_baike_home')
        },
        computed:{
            homeData(){
                if (this.$store.state.baike_home){
                    if (this.$store.state.baike_home.data){
                        let data = this.$store.state.baike_home.data;
                        // console.log(data)
                        return data;
                    }else {
                        return false
                    }
                }else {
                    return false
                }
            },
        },
        mounted(){
            if (this.$publicObj.getCookie('platform') == 'android'){
                history.pushState(null, null, location.href);
                window.addEventListener('popstate', function (event) {
                    history.pushState(null, null, location.href);
                    window.android.onBack()
                },false);
            }    
        },

        methods:{
            // 点击切换选项
            search_btn(num){
                this.search_index = num
            },
            getOrderShow(){
                // console.log('登录了')
            },
            // 点击返回
            baike_back(){
                if (this.$publicObj.getCookie('platform')){
                    // iosAPP
                    if (this.$publicObj.getCookie('platform') == 'ios') {
                        // this.$publicObj.layerFun('走了');
                        // _this.$publicObj.layerFun('出错了');
                        window.webkit.messageHandlers.iOSAPPFuncation.postMessage({'body': 'backAppVC'});
                        //安卓App
                    }else {
                        window.android.onBack();

                    }
                    return
                } else {
                    window.history.back(-1); 
                }
            }
        },
        created() {

        }
    }
</script>

<style scoped>
    .head_box {
        height: 1.877333rem;
    }
    
    .head_top_box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 1.877333rem;
        z-index: 100;
    }
    
    .head_top {
        display: flex;
        width: 100%;
        min-width: 8rem;
        max-width: 16rem;
        margin: 0 auto;
        height: 1.877333rem;
        background-color: #fff;
    }
    
    .head_top a {
        display: block;
        width: 2.56rem;
        height: 1.877333rem;
    }
    
    .head_top a img {
        display: block;
        height: 1.28rem;
        margin: 0 auto;
        padding: 0.298666rem;
    }
    
    .head_top h1 {
        flex: 1;
        text-align: center;
        height: 1.877333rem;
        line-height: 1.877333rem;
        font-size: 0.768rem;
        color: #333;
        font-weight: 500;
    }
    
    .head_top .head_top_btn {
        display: block;
        width: 2.56rem;
        height: 1.877333rem;
    }
    
    /* 搜索 */
    .search_box {
        height: 7.786666rem;
        padding: 0 1.642666rem;
        background-image: url(../../assets/images/index/baike_bg.png);
        background-size: 100% 100%;
        overflow: hidden;
    }
    
    .search_box .search_btn {
        display: flex;
        width: 100%;
        margin-top: 1.664rem;
        margin-bottom: 0.2rem;
        padding-bottom: 0.3rem;
        overflow-x: scroll;
    }
    
    .search_box .search_btn_list {
        position: relative;
        padding: 0 0.426666rem;
        height: 1rem;
        text-align: center;
        line-height: 1rem;
        color: #fff;
        font-size: 0.597333rem;
        margin-right: .4rem;
        flex-shrink: 0;
    }
    
    .search_box .search_btn_list p {
        position: absolute;
        left: 50%;
        bottom: -0.682666rem;
        margin-left: -0.341333rem;
        border-top: 0.341333rem solid rgba(0,0,0,0);
        border-left: 0.341333rem solid rgba(0,0,0,0);
        border-right: 0.341333rem solid rgba(0,0,0,0);
        border-bottom: 0.341333rem solid rgba(0,0,0,0);
    }
    
    .search_box .search_btn_list.active {
        background-color: #fff;
        color: #000;
        border-radius: 0.1rem;
    }
    
    .search_box .search_btn_list.active p {
        border-top: 0.341333rem solid #fff;
    }
    
    .search {
        display: flex;
        align-items: center;
        width: 100%;
        height: 1.706666rem;
        border-radius: 5px;
        overflow: hidden;
        box-shadow:0px 1px 3px 0px rgba(20,90,140,0.69);
    }
    
    .search input {
        flex: 1;
        height: 1.706666rem;
        vertical-align: top;
        border: 0;
        padding: 0 0.426666rem;
        color: #999;
        font-size: 0.597333rem;
    }
    
    .search .search_state {
        width: 2.346666rem;
        height: 1.706666rem;
        background-color: #006AB8;
    }
    
    .search .search_state img {
        display: block;
        margin: 0.426666rem auto;
        width: 0.853333rem;
        height: 0.853333rem;
    }
    
    .hot_search {
        display: flex;
        width: 100%;
        margin-top: 0.768rem;
    }
    
    .hot_search .hot_title {
        color: #C7E4FF;
        font-size: 0.512rem;
    }
    
    .hot_search .hot_list {
        color: #fff;
        margin-left: 0.597333rem;
        font-size: 0.512rem;
    }
    
    .hot_search .hot_list a {
        color: #fff;
        font-size: 0.512rem;
    }
    
    /* 主体 */
    .index  {
        width: 100%;
    }
    
    .index_list_title {
        display: flex;
        align-items: flex-end;
        width: 100%;
        padding-top: 0.426666rem;
        height: 1rem;
        background-color: #fff;
    }
    
    .index_list_title h2 {
        flex: 1;
        font-size: 0.682666rem;
        font-weight: 500;
        height: 0.64rem;
        line-height: 0.6rem;
        padding-left: 0.128rem;
        border-left: 0.384rem solid #3fabfa;
    }
    
    .index_list_title .more {
        color: #3fabfa;
        font-size: 0.512rem;
        margin-right: 0.512rem;
    }
    /* 词条 */
    .new_entry {
        width: 100%;
    }
    
    .entry_box {
        display: flex;
        width: 100%;
        overflow-x: scroll;
        padding-top: 0.64rem;
    }
    
    .entry_box::-webkit-scrollbar , .search_box .search_btn::-webkit-scrollbar{
        display:none
    }
    
    .entry_box .entry_list {
        width: 7.253333rem;
        flex-shrink: 0;
        margin-right: 0.256rem;
    }
    
    .entry_box .entry_list:first-child {
        margin-left: 0.512rem;
    }
    
    .entry_box .entry_list:last-child {
        margin-right: 0.512rem;
    }
    
    .entry_box .entry_list a {
        display: block;
        width: 100%;
    }
    
    .entry_box .entry_list .entry_img {
        display: block;
        width: 100%;
        position: relative;
    }
    
    .entry_box .entry_list img {
        display: block;
        width: 100%;
        height: 4.650666rem;
    }
    
    .entry_box .entry_list .label {
        position: absolute;
        bottom: 0.213333rem;
        left: 0.213333rem;
        height: 0.853333rem;
        line-height: 0.853333rem;
        background-color: #FAC535;
        color: #fff;
        padding: 0 0.128rem;
    }
    
    .entry_box .entry_list .entry_title {
        margin-top: 0.128rem;
        margin-bottom: 0.256rem;
        font-size: 0.554666rem;
        color: #333;
        font-weight: 500;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    
    .entry_box .entry_list .entry_time {
        font-size: 0.469333rem;
        color: #999;
    }
    
    /* 热搜小区 */
    .hot_xq {
        background-color: #F8F8F8;
        overflow: hidden;
    }
    
    .hot_xq_list {
        padding: 0.64rem 0 0;
        background-color: #fff;
        margin-bottom: 0.682666rem;
    }
    
    .hot_xq_list a {
        display: flex;
        flex-wrap: wrap;
    }
    
    .hot_xq_img {
        width: 3.370666rem;
        height: 3.370666rem;
        margin-right: 0.64rem;
        margin-left: 0.512rem;
        vertical-align: top;
        margin-bottom: 0.853333rem;
    }
    
    .hot_xq_img img {
        width: 3.370666rem;
        height: 3.370666rem;
    }
    
    .hot_xq_box {
        flex: 1;
        margin-right: 0.512rem;
    }
    
    .hot_xq_box .hot_xq_title {
        display: block;
        font-size: 0.768rem;
        color: #333;
        font-weight: 500;
        margin-bottom: 0.426666rem;
    }
    
    .hot_xq_box .hot_xq_i {
        display: flex;
        align-items: center;
    }
    
    .hot_xq_box .hot_xq_i_list {
        flex: 1;
        text-align: center;
        padding: 0.128rem 0;
    }
    
    .hot_xq_box .hot_xq_i .hot_xq_i_list:first-child {
        border-right: 1px solid #eee;
    }
    
    .hot_xq_box .hot_xq_i_title {
        font-size: 0.554666rem;
        color: #999;
        margin-bottom: 0.213333rem;
    }
    
    .hot_xq_box .hot_xq_i_text {
        font-size: 0.554666rem;
        color: #333;
    }
    
    .hot_xq_bot {
        display: flex;
        width: 100%;
        border-top: 1px solid #eee;
        padding: 0.426666rem 0.512rem;
        margin-top: 0.853333rem;
        overflow: hidden;
    }
    
    .hot_xq_bot img {
        height: 0.725333rem;
    }
    
    .hot_xq_bot .hot_xq_bot_title {
        vertical-align: top;
        font-size: 0.554666rem;
        color: #333;
        margin-left: 0.298666rem;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    
    /* 热搜企业 */
    .hot_company {
        background-color: #F8F8F8;
        overflow: hidden;
    }
    
    .hot_company_list {
        padding: 0.64rem 0 0;
        background-color: #fff;
        margin-bottom: 0.682666rem;
    }
    
    .hot_company_list a {
        display: flex;
        flex-wrap: wrap;
    }
    
    .hot_company_img {
        width: 3.370666rem;
        height: 3.370666rem;
        margin-right: 0.64rem;
        margin-left: 0.512rem;
        vertical-align: top;
    }
    
    .hot_company_img img {
        width: 3.370666rem;
        height: 3.370666rem;
    }
    
    .hot_company_box {
        flex: 1;
        margin-right: 0.512rem;
        width: 200px;
    }
    
    .hot_company_box .hot_company_title {
        display: block;
        font-size: 0.768rem;
        color: #333;
        font-weight: 500;
        margin-bottom: 0.426666rem;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    
    .hot_company_box .hot_company_i {
        display: flex;
        align-items: center;
    }
    
    .hot_company_box .hot_company_i_list {
        flex: 1;
        text-align: center;
        padding: 0.128rem 0;
    }
    
    .hot_company_box .hot_company_i .hot_company_i_list:first-child {
        border-right: 1px solid #eee;
    }
    
    .hot_company_box .hot_company_i_title {
        font-size: 0.554666rem;
        color: #999;
        margin-bottom: 0.213333rem;
    }
    
    .hot_company_box .hot_company_i_text {
        font-size: 0.554666rem;
        color: #333;
    }
    
    .hot_company_bot {
        display: flex;
        width: 100%;
        border-top: 1px solid #eee;
        padding: 0.426666rem 0.512rem;
    }
    
    .hot_company_bot img {
        height: 0.725333rem;
    }
    
    .hot_company_bot .hot_company_bot_title {
        vertical-align: top;
        font-size: 0.554666rem;
        color: #333;
        margin-left: 0.298666rem;
    }
</style>


// WEBPACK FOOTER //
// index.vue